<template>
  <div class="d-flex">
    <v-btn
      @click="$vuetify.goTo(selector, {duration: 2000})"
      text
      :color="color"
      class="text-capitalize text-body-2"
      x-small
    >{{ $t(`${trans}${selector.split('#')[1]}`) }}</v-btn>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ["selector", "trans", "color"]
};
</script>

<style lang="scss" scoped>
</style>